export enum ContractModality {
  WITH_COMMITMENT = 'with_commitment',
  WITHOUT_COMMITMENT = 'without_commitment',
}
